import $ from 'jquery';

$(document).ready(function() {
    $('.js-slide-authors').slick({
        dots: false,
        slidesToShow: 1.2,
        centerMode: false,
        variableWidth: false,
        arrows: true,
        infinite: false,
        draggable: false,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2.2,
               }
            },
            {
                breakpoint: 1024,
                settings: "unslick",
            }, 
        ]
    });
    $(window).trigger('resize');
});


// WEBPACK FOOTER //
// ./src/js/pages/one-theme/authors.js